// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  queryOptions,
  type UseMutationOptions,
} from '@tanstack/react-query';

import { client } from '../client.gen';
import {
  add,
  addContentFeedback,
  addCourse,
  assignUsersToChecklist,
  assignUsersToChecklist1,
  assignUsersToChecklist2,
  assignUsersToChecklist3,
  clearContentCache,
  createChecklistFromTemplate,
  createCustomQuiz,
  createCustomQuiz1,
  createLocationPlansFromTemplates,
  createMarketTest,
  delete_,
  deleteCategoryByCountryCodeAndId,
  deleteChecklist,
  deleteChecklist1,
  deleteChecklist2,
  deleteContentFeedback,
  deleteCourse,
  deleteCustomQuiz,
  deleteCustomQuiz1,
  deleteDocument,
  deleteMarketTest,
  deleteOperatorLike,
  deleteSubcategory,
  deleteSubtitle,
  duplicateChecklist,
  duplicateChecklist1,
  duplicateChecklist2,
  duplicateChecklistTemplate,
  duplicateChecklistTemplate1,
  generateCourseReport,
  getAll,
  getAllCourses,
  getAllMarketTests,
  getAscendOnDemandCourses,
  getById,
  getCategoryByCountryCode,
  getCategoryById,
  getCategoryIcons,
  getChecklist,
  getChecklist1,
  getChecklist2,
  getChecklistByUserIds,
  getChecklistByUserIds1,
  getComplianceCourses,
  getCourseById,
  getCurrentUserLocations,
  getCustomQuizDetails,
  getCustomQuizDetails1,
  getCustomQuizzes,
  getCustomQuizzes1,
  getDocument,
  getFilteredPlans,
  getFilteredPlans1,
  getJobStatus,
  getLeadershipCourses,
  getLocationsByConceptType,
  getMarketTestById,
  getMarketTestDocuments,
  getMarketTestsByLocation,
  getMyMarketTests,
  getOperatorCourseSettings,
  getProcedureIcons,
  getSqssl,
  getSubcategory,
  getSubtitle,
  getTeamMembersStatusReport,
  getTeamMembersStatusReport1,
  getTemplates,
  getVideoContent,
  learnUponWebhook,
  learnUponWebhookV2,
  listAllChecklists,
  listAssignableChecklists,
  listAssignableChecklists1,
  listAssignableChecklists2,
  listAssignedByChecklist,
  listAssignedByChecklist1,
  listAssignedByChecklist2,
  listAssignedChecklists,
  listAssignedChecklists1,
  listChecklists,
  listChecklists1,
  listChecklistTemplates,
  listChecklistTemplates1,
  listEditableChecklists,
  listEditableChecklists1,
  listEditableChecklists2,
  listEnrollmentsByCourse,
  listMyChecklists,
  listMyChecklists1,
  listOperators,
  listRelatedDocuments,
  listSubcategories,
  listSubtitles,
  listUsers,
  migrateFolder,
  newIndexDocument,
  newIndexDocument1,
  type Options,
  refreshFoodSafetyLettersCache,
  reportPlans,
  reportTeamMember,
  reportTeamMembers,
  reportUsersProgress,
  resetAllChecklistStepsState,
  resetAllChecklistStepsState1,
  resetAllChecklistStepsState2,
  retrieveUserPreferences,
  saveCategories,
  saveCategory,
  saveChecklist,
  saveChecklist1,
  saveChecklist2,
  saveDocuments,
  saveSubcategories,
  saveSubtitles,
  saveUserPreferences,
  setAuthCookie,
  setDueDateOnChecklist,
  setDueDateOnChecklist1,
  setDueDateOnChecklist2,
  setMarketTestProcedures,
  setOperatorCourseSetting,
  setOperatorLike,
  stepHeartbeat,
  synchronizeUser,
  translate,
  typeformQuiz,
  unassignUsersToChecklist,
  unassignUsersToChecklist1,
  unassignUsersToChecklist2,
  update,
  updateChecklist,
  updateChecklist1,
  updateChecklist2,
  updateChecklistStatus,
  updateChecklistStatus1,
  updateChecklistStatus2,
  updateChecklistStepStatus,
  updateChecklistStepStatus1,
  updateCourse,
  updateCustomQuiz,
  updateCustomQuiz1,
  updateMarketTest,
  updateStepStatus,
  updateUserComplianceCourseDuration,
} from '../sdk.gen';
import type {
  AddContentFeedbackData,
  AddContentFeedbackError,
  AddContentFeedbackResponse,
  AddCourseData,
  AddCourseError,
  AddCourseResponse,
  AddData,
  AddError,
  AddResponse,
  AssignUsersToChecklist1Data,
  AssignUsersToChecklist1Error,
  AssignUsersToChecklist2Data,
  AssignUsersToChecklist2Error,
  AssignUsersToChecklist3Data,
  AssignUsersToChecklistData,
  AssignUsersToChecklistError,
  ClearContentCacheData,
  ClearContentCacheError,
  CreateChecklistFromTemplateData,
  CreateChecklistFromTemplateError,
  CreateChecklistFromTemplateResponse,
  CreateCustomQuiz1Data,
  CreateCustomQuiz1Error,
  CreateCustomQuiz1Response,
  CreateCustomQuizData,
  CreateCustomQuizError,
  CreateCustomQuizResponse,
  CreateLocationPlansFromTemplatesData,
  CreateLocationPlansFromTemplatesError,
  CreateLocationPlansFromTemplatesResponse,
  CreateMarketTestData,
  CreateMarketTestError,
  DeleteCategoryByCountryCodeAndIdData,
  DeleteCategoryByCountryCodeAndIdError,
  DeleteCategoryByCountryCodeAndIdResponse,
  DeleteChecklist1Data,
  DeleteChecklist1Error,
  DeleteChecklist2Data,
  DeleteChecklistData,
  DeleteChecklistError,
  DeleteContentFeedbackData,
  DeleteContentFeedbackError,
  DeleteCourseData,
  DeleteCourseError,
  DeleteCustomQuiz1Data,
  DeleteCustomQuiz1Error,
  DeleteCustomQuizData,
  DeleteCustomQuizError,
  DeleteCustomQuizResponse,
  DeleteData,
  DeleteDocumentData,
  DeleteDocumentError,
  DeleteDocumentResponse,
  DeleteError,
  DeleteMarketTestData,
  DeleteMarketTestError,
  DeleteMarketTestResponse,
  DeleteOperatorLikeData,
  DeleteOperatorLikeError,
  DeleteSubcategoryData,
  DeleteSubcategoryResponse,
  DeleteSubtitleData,
  DeleteSubtitleResponse,
  DuplicateChecklist1Data,
  DuplicateChecklist1Error,
  DuplicateChecklist1Response,
  DuplicateChecklist2Data,
  DuplicateChecklist2Error,
  DuplicateChecklist2Response,
  DuplicateChecklistData,
  DuplicateChecklistError,
  DuplicateChecklistResponse2 as DuplicateChecklistResponse,
  DuplicateChecklistTemplate1Data,
  DuplicateChecklistTemplate1Error,
  DuplicateChecklistTemplate1Response,
  DuplicateChecklistTemplateData,
  DuplicateChecklistTemplateError,
  DuplicateChecklistTemplateResponse2 as DuplicateChecklistTemplateResponse,
  GenerateCourseReportData,
  GetAllCoursesData,
  GetAllData,
  GetAllMarketTestsData,
  GetAscendOnDemandCoursesData,
  GetByIdData,
  GetCategoryByCountryCodeData,
  GetCategoryByIdData,
  GetCategoryIconsData,
  GetChecklist1Data,
  GetChecklist2Data,
  GetChecklistByUserIds1Data,
  GetChecklistByUserIdsData,
  GetChecklistData,
  GetComplianceCoursesData,
  GetCourseByIdData,
  GetCurrentUserLocationsData,
  GetCustomQuizDetails1Data,
  GetCustomQuizDetailsData,
  GetCustomQuizzes1Data,
  GetCustomQuizzesData,
  GetDocumentData,
  GetFilteredPlans1Data,
  GetFilteredPlans1Error,
  GetFilteredPlans1Response,
  GetFilteredPlansData,
  GetFilteredPlansError,
  GetFilteredPlansResponse,
  GetJobStatusData,
  GetLeadershipCoursesData,
  GetLocationsByConceptTypeData,
  GetMarketTestByIdData,
  GetMarketTestDocumentsData,
  GetMarketTestsByLocationData,
  GetMyMarketTestsData,
  GetOperatorCourseSettingsData,
  GetProcedureIconsData,
  GetSqsslData,
  GetSubcategoryData,
  GetSubtitleData,
  GetTeamMembersStatusReport1Data,
  GetTeamMembersStatusReportData,
  GetTemplatesData,
  GetVideoContentData,
  LearnUponWebhookData,
  LearnUponWebhookError,
  LearnUponWebhookResponse,
  LearnUponWebhookV2Data,
  LearnUponWebhookV2Error,
  LearnUponWebhookV2Response,
  ListAllChecklistsData,
  ListAssignableChecklists1Data,
  ListAssignableChecklists2Data,
  ListAssignableChecklistsData,
  ListAssignedByChecklist1Data,
  ListAssignedByChecklist2Data,
  ListAssignedByChecklistData,
  ListAssignedChecklists1Data,
  ListAssignedChecklistsData,
  ListChecklists1Data,
  ListChecklistsData,
  ListChecklistTemplates1Data,
  ListChecklistTemplatesData,
  ListEditableChecklists1Data,
  ListEditableChecklists2Data,
  ListEditableChecklistsData,
  ListEnrollmentsByCourseData,
  ListMyChecklists1Data,
  ListMyChecklistsData,
  ListOperatorsData,
  ListRelatedDocumentsData,
  ListSubcategoriesData,
  ListSubtitlesData,
  ListUsersData,
  MigrateFolderData,
  MigrateFolderError,
  NewIndexDocument1Data,
  NewIndexDocument1Error,
  NewIndexDocument1Response,
  NewIndexDocumentData,
  NewIndexDocumentError,
  NewIndexDocumentResponse,
  RefreshFoodSafetyLettersCacheData,
  RefreshFoodSafetyLettersCacheError,
  RefreshFoodSafetyLettersCacheResponse,
  ReportPlansData,
  ReportTeamMemberData,
  ReportTeamMembersData,
  ReportUsersProgressData,
  ResetAllChecklistStepsState1Data,
  ResetAllChecklistStepsState1Error,
  ResetAllChecklistStepsState1Response,
  ResetAllChecklistStepsState2Data,
  ResetAllChecklistStepsState2Error,
  ResetAllChecklistStepsState2Response,
  ResetAllChecklistStepsStateData,
  ResetAllChecklistStepsStateError,
  ResetAllChecklistStepsStateResponse,
  RetrieveUserPreferencesData,
  SaveCategoriesData,
  SaveCategoriesError,
  SaveCategoriesResponse,
  SaveCategoryData,
  SaveCategoryError,
  SaveCategoryResponse,
  SaveChecklist1Data,
  SaveChecklist1Error,
  SaveChecklist1Response,
  SaveChecklist2Data,
  SaveChecklist2Error,
  SaveChecklist2Response,
  SaveChecklistData,
  SaveChecklistError,
  SaveChecklistResponse,
  SaveDocumentsData,
  SaveDocumentsError,
  SaveSubcategoriesData,
  SaveSubtitlesData,
  SaveUserPreferencesData,
  SaveUserPreferencesError,
  SaveUserPreferencesResponse,
  SetAuthCookieData,
  SetDueDateOnChecklist1Data,
  SetDueDateOnChecklist1Error,
  SetDueDateOnChecklist2Data,
  SetDueDateOnChecklistData,
  SetDueDateOnChecklistError,
  SetMarketTestProceduresData,
  SetMarketTestProceduresError,
  SetOperatorCourseSettingData,
  SetOperatorCourseSettingError,
  SetOperatorLikeData,
  SetOperatorLikeError,
  StepHeartbeatData,
  StepHeartbeatError,
  SynchronizeUserData,
  SynchronizeUserError,
  TranslateData,
  TranslateError,
  TranslateResponse,
  TypeformQuizData,
  TypeformQuizError,
  UnassignUsersToChecklist1Data,
  UnassignUsersToChecklist1Error,
  UnassignUsersToChecklist2Data,
  UnassignUsersToChecklistData,
  UnassignUsersToChecklistError,
  UpdateChecklist1Data,
  UpdateChecklist1Error,
  UpdateChecklist2Data,
  UpdateChecklistData,
  UpdateChecklistError,
  UpdateChecklistStatus1Data,
  UpdateChecklistStatus1Error,
  UpdateChecklistStatus2Data,
  UpdateChecklistStatusData,
  UpdateChecklistStatusError,
  UpdateChecklistStepStatus1Data,
  UpdateChecklistStepStatusData,
  UpdateChecklistStepStatusError,
  UpdateCourseData,
  UpdateCourseError,
  UpdateCourseResponse,
  UpdateCustomQuiz1Data,
  UpdateCustomQuiz1Error,
  UpdateCustomQuiz1Response,
  UpdateCustomQuizData,
  UpdateCustomQuizError,
  UpdateCustomQuizResponse,
  UpdateData,
  UpdateError,
  UpdateMarketTestData,
  UpdateMarketTestError,
  UpdateResponse,
  UpdateStepStatusData,
  UpdateStepStatusError,
  UpdateUserComplianceCourseDurationData,
  UpdateUserComplianceCourseDurationError,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl:
      options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getVideoContentQueryKey = (
  options?: Options<GetVideoContentData>,
) => createQueryKey('getVideoContent', options);

/**
 * Get raw content by documentGuid
 */
export const getVideoContentOptions = (
  options?: Options<GetVideoContentData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getVideoContent({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getVideoContentQueryKey(options),
  });
};

/**
 * Clear the content cache
 */
export const clearContentCacheMutation = (
  options?: Partial<Options<ClearContentCacheData>>,
): UseMutationOptions<
  unknown,
  ClearContentCacheError,
  Options<ClearContentCacheData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ClearContentCacheError,
    Options<ClearContentCacheData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await clearContentCache({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Refresh food safety letters cache (requires scope: pathway-content:maintenance)
 */
export const refreshFoodSafetyLettersCacheMutation = (
  options?: Partial<Options<RefreshFoodSafetyLettersCacheData>>,
): UseMutationOptions<
  RefreshFoodSafetyLettersCacheResponse,
  RefreshFoodSafetyLettersCacheError,
  Options<RefreshFoodSafetyLettersCacheData>
> => {
  const mutationOptions: UseMutationOptions<
    RefreshFoodSafetyLettersCacheResponse,
    RefreshFoodSafetyLettersCacheError,
    Options<RefreshFoodSafetyLettersCacheData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await refreshFoodSafetyLettersCache({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCategoryByCountryCodeQueryKey = (
  options?: Options<GetCategoryByCountryCodeData>,
) => createQueryKey('getCategoryByCountryCode', options);

/**
 * Get Categories by Country Code
 */
export const getCategoryByCountryCodeOptions = (
  options?: Options<GetCategoryByCountryCodeData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCategoryByCountryCode({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCategoryByCountryCodeQueryKey(options),
  });
};

/**
 * Add or update Categories List
 */
export const saveCategoriesMutation = (
  options?: Partial<Options<SaveCategoriesData>>,
): UseMutationOptions<
  SaveCategoriesResponse,
  SaveCategoriesError,
  Options<SaveCategoriesData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveCategoriesResponse,
    SaveCategoriesError,
    Options<SaveCategoriesData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await saveCategories({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add or update single category
 */
export const saveCategoryMutation = (
  options?: Partial<Options<SaveCategoryData>>,
): UseMutationOptions<
  SaveCategoryResponse,
  SaveCategoryError,
  Options<SaveCategoryData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveCategoryResponse,
    SaveCategoryError,
    Options<SaveCategoryData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await saveCategory({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete category by Country and ID
 */
export const deleteCategoryByCountryCodeAndIdMutation = (
  options?: Partial<Options<DeleteCategoryByCountryCodeAndIdData>>,
): UseMutationOptions<
  DeleteCategoryByCountryCodeAndIdResponse,
  DeleteCategoryByCountryCodeAndIdError,
  Options<DeleteCategoryByCountryCodeAndIdData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteCategoryByCountryCodeAndIdResponse,
    DeleteCategoryByCountryCodeAndIdError,
    Options<DeleteCategoryByCountryCodeAndIdData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteCategoryByCountryCodeAndId({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCategoryByIdQueryKey = (
  options: Options<GetCategoryByIdData>,
) => createQueryKey('getCategoryById', options);

/**
 * Get Category by Id
 */
export const getCategoryByIdOptions = (
  options: Options<GetCategoryByIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCategoryById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCategoryByIdQueryKey(options),
  });
};

/**
 * Create a checklist
 * @deprecated
 */
export const saveChecklist2Mutation = (
  options?: Partial<Options<SaveChecklist2Data>>,
): UseMutationOptions<
  SaveChecklist2Response,
  SaveChecklist2Error,
  Options<SaveChecklist2Data>
> => {
  const mutationOptions: UseMutationOptions<
    SaveChecklist2Response,
    SaveChecklist2Error,
    Options<SaveChecklist2Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await saveChecklist2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update a checklist
 * @deprecated
 */
export const updateChecklist2Mutation = (
  options?: Partial<Options<UpdateChecklist2Data>>,
): UseMutationOptions<unknown, DefaultError, Options<UpdateChecklist2Data>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<UpdateChecklist2Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateChecklist2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listChecklists1QueryKey = (
  options?: Options<ListChecklists1Data>,
) => createQueryKey('listChecklists1', options);

/**
 * List all training checklists
 * @deprecated
 */
export const listChecklists1Options = (
  options?: Options<ListChecklists1Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listChecklists1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listChecklists1QueryKey(options),
  });
};

export const listAssignableChecklists2QueryKey = (
  options?: Options<ListAssignableChecklists2Data>,
) => createQueryKey('listAssignableChecklists2', options);

/**
 * List all training checklists the active user can assign users to, as well as their assigned counts
 * @deprecated
 */
export const listAssignableChecklists2Options = (
  options?: Options<ListAssignableChecklists2Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAssignableChecklists2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAssignableChecklists2QueryKey(options),
  });
};

export const listAssignedChecklists1QueryKey = (
  options?: Options<ListAssignedChecklists1Data>,
) => createQueryKey('listAssignedChecklists1', options);

/**
 * List assigned training checklists
 * @deprecated
 */
export const listAssignedChecklists1Options = (
  options?: Options<ListAssignedChecklists1Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAssignedChecklists1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAssignedChecklists1QueryKey(options),
  });
};

export const listAssignedByChecklist2QueryKey = (
  options: Options<ListAssignedByChecklist2Data>,
) => createQueryKey('listAssignedByChecklist2', options);

/**
 * Status of all assigned users to this training checklist
 * @deprecated
 */
export const listAssignedByChecklist2Options = (
  options: Options<ListAssignedByChecklist2Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAssignedByChecklist2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAssignedByChecklist2QueryKey(options),
  });
};

export const getTeamMembersStatusReport1QueryKey = (
  options?: Options<GetTeamMembersStatusReport1Data>,
) => createQueryKey('getTeamMembersStatusReport1', options);

/**
 * Get checklist status report for team members
 * @deprecated
 */
export const getTeamMembersStatusReport1Options = (
  options?: Options<GetTeamMembersStatusReport1Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTeamMembersStatusReport1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTeamMembersStatusReport1QueryKey(options),
  });
};

export const listEditableChecklists2QueryKey = (
  options?: Options<ListEditableChecklists2Data>,
) => createQueryKey('listEditableChecklists2', options);

/**
 * List all training checklists the active user can edit/modify
 * @deprecated
 */
export const listEditableChecklists2Options = (
  options?: Options<ListEditableChecklists2Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listEditableChecklists2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listEditableChecklists2QueryKey(options),
  });
};

export const listMyChecklists1QueryKey = (
  options?: Options<ListMyChecklists1Data>,
) => createQueryKey('listMyChecklists1', options);

/**
 * List assigned training checklists
 * @deprecated
 */
export const listMyChecklists1Options = (
  options?: Options<ListMyChecklists1Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listMyChecklists1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listMyChecklists1QueryKey(options),
  });
};

/**
 * Reset current state of Checklist for a user
 * @deprecated
 */
export const resetAllChecklistStepsState2Mutation = (
  options?: Partial<Options<ResetAllChecklistStepsState2Data>>,
): UseMutationOptions<
  ResetAllChecklistStepsState2Response,
  ResetAllChecklistStepsState2Error,
  Options<ResetAllChecklistStepsState2Data>
> => {
  const mutationOptions: UseMutationOptions<
    ResetAllChecklistStepsState2Response,
    ResetAllChecklistStepsState2Error,
    Options<ResetAllChecklistStepsState2Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await resetAllChecklistStepsState2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listChecklistTemplates1QueryKey = (
  options?: Options<ListChecklistTemplates1Data>,
) => createQueryKey('listChecklistTemplates1', options);

/**
 * List all training checklist templates
 * @deprecated
 */
export const listChecklistTemplates1Options = (
  options?: Options<ListChecklistTemplates1Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listChecklistTemplates1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listChecklistTemplates1QueryKey(options),
  });
};

/**
 * Duplicate a checklist template
 * @deprecated
 */
export const duplicateChecklistTemplate1Mutation = (
  options?: Partial<Options<DuplicateChecklistTemplate1Data>>,
): UseMutationOptions<
  DuplicateChecklistTemplate1Response,
  DuplicateChecklistTemplate1Error,
  Options<DuplicateChecklistTemplate1Data>
> => {
  const mutationOptions: UseMutationOptions<
    DuplicateChecklistTemplate1Response,
    DuplicateChecklistTemplate1Error,
    Options<DuplicateChecklistTemplate1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await duplicateChecklistTemplate1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Unassign one or more Team members to a Checklist
 * @deprecated
 */
export const unassignUsersToChecklist2Mutation = (
  options?: Partial<Options<UnassignUsersToChecklist2Data>>,
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<UnassignUsersToChecklist2Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<UnassignUsersToChecklist2Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await unassignUsersToChecklist2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Assign one or more Team members to a Checklist
 * @deprecated
 */
export const assignUsersToChecklist3Mutation = (
  options?: Partial<Options<AssignUsersToChecklist3Data>>,
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<AssignUsersToChecklist3Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<AssignUsersToChecklist3Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await assignUsersToChecklist3({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set Due Date on one or more Team members assigned to a Checklist
 * @deprecated
 */
export const setDueDateOnChecklist2Mutation = (
  options?: Partial<Options<SetDueDateOnChecklist2Data>>,
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<SetDueDateOnChecklist2Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<SetDueDateOnChecklist2Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await setDueDateOnChecklist2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set checklist status by ID
 * @deprecated
 */
export const updateChecklistStatus2Mutation = (
  options?: Partial<Options<UpdateChecklistStatus2Data>>,
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<UpdateChecklistStatus2Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<UpdateChecklistStatus2Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateChecklistStatus2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set checklist step status by ID
 * @deprecated
 */
export const updateChecklistStepStatus1Mutation = (
  options?: Partial<Options<UpdateChecklistStepStatus1Data>>,
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<UpdateChecklistStepStatus1Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<UpdateChecklistStepStatus1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateChecklistStepStatus1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getChecklistByUserIds1QueryKey = (
  options: Options<GetChecklistByUserIds1Data>,
) => createQueryKey('getChecklistByUserIds1', options);

/**
 * Get User Checklist by Checklist ID and User IDs
 * @deprecated
 */
export const getChecklistByUserIds1Options = (
  options: Options<GetChecklistByUserIds1Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getChecklistByUserIds1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getChecklistByUserIds1QueryKey(options),
  });
};

/**
 * Delete checklist by ID
 * @deprecated
 */
export const deleteChecklist2Mutation = (
  options?: Partial<Options<DeleteChecklist2Data>>,
): UseMutationOptions<unknown, DefaultError, Options<DeleteChecklist2Data>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<DeleteChecklist2Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteChecklist2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getChecklist2QueryKey = (options: Options<GetChecklist2Data>) =>
  createQueryKey('getChecklist2', options);

/**
 * Get checklist by ID
 * @deprecated
 */
export const getChecklist2Options = (options: Options<GetChecklist2Data>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getChecklist2({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getChecklist2QueryKey(options),
  });
};

/**
 * Duplicate a checklist
 * @deprecated
 */
export const duplicateChecklist2Mutation = (
  options?: Partial<Options<DuplicateChecklist2Data>>,
): UseMutationOptions<
  DuplicateChecklist2Response,
  DuplicateChecklist2Error,
  Options<DuplicateChecklist2Data>
> => {
  const mutationOptions: UseMutationOptions<
    DuplicateChecklist2Response,
    DuplicateChecklist2Error,
    Options<DuplicateChecklist2Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await duplicateChecklist2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAllCoursesQueryKey = (options?: Options<GetAllCoursesData>) =>
  createQueryKey('getAllCourses', options);

/**
 * List All Courses
 */
export const getAllCoursesOptions = (options?: Options<GetAllCoursesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllCourses({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllCoursesQueryKey(options),
  });
};

/**
 * Add a Course
 */
export const addCourseMutation = (
  options?: Partial<Options<AddCourseData>>,
): UseMutationOptions<
  AddCourseResponse,
  AddCourseError,
  Options<AddCourseData>
> => {
  const mutationOptions: UseMutationOptions<
    AddCourseResponse,
    AddCourseError,
    Options<AddCourseData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await addCourse({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Assign one or more Team members to a Checklist
 */
export const assignUsersToChecklist2Mutation = (
  options?: Partial<Options<AssignUsersToChecklist2Data>>,
): UseMutationOptions<
  unknown,
  AssignUsersToChecklist2Error,
  Options<AssignUsersToChecklist2Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AssignUsersToChecklist2Error,
    Options<AssignUsersToChecklist2Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await assignUsersToChecklist2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listEnrollmentsByCourseQueryKey = (
  options: Options<ListEnrollmentsByCourseData>,
) => createQueryKey('listEnrollmentsByCourse', options);

/**
 * Status of all current enrollments to this course by optional location
 */
export const listEnrollmentsByCourseOptions = (
  options: Options<ListEnrollmentsByCourseData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listEnrollmentsByCourse({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listEnrollmentsByCourseQueryKey(options),
  });
};

export const getComplianceCoursesQueryKey = (
  options?: Options<GetComplianceCoursesData>,
) => createQueryKey('getComplianceCourses', options);

/**
 * Gets compliance courses based on country selected in user's profile
 */
export const getComplianceCoursesOptions = (
  options?: Options<GetComplianceCoursesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getComplianceCourses({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getComplianceCoursesQueryKey(options),
  });
};

export const generateCourseReportQueryKey = (
  options: Options<GenerateCourseReportData>,
) => createQueryKey('generateCourseReport', options);

/**
 * Sensitive data report on course by location
 */
export const generateCourseReportOptions = (
  options: Options<GenerateCourseReportData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await generateCourseReport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: generateCourseReportQueryKey(options),
  });
};

export const getOperatorCourseSettingsQueryKey = (
  options: Options<GetOperatorCourseSettingsData>,
) => createQueryKey('getOperatorCourseSettings', options);

/**
 * Returns course settings for an operator
 */
export const getOperatorCourseSettingsOptions = (
  options: Options<GetOperatorCourseSettingsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOperatorCourseSettings({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOperatorCourseSettingsQueryKey(options),
  });
};

/**
 * Enables or Disables a course for an operator
 */
export const setOperatorCourseSettingMutation = (
  options?: Partial<Options<SetOperatorCourseSettingData>>,
): UseMutationOptions<
  unknown,
  SetOperatorCourseSettingError,
  Options<SetOperatorCourseSettingData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    SetOperatorCourseSettingError,
    Options<SetOperatorCourseSettingData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await setOperatorCourseSetting({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSqsslQueryKey = (options: Options<GetSqsslData>) =>
  createQueryKey('getSqssl', options);

/**
 * Get SQSSO
 */
export const getSqsslOptions = (options: Options<GetSqsslData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSqssl({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSqsslQueryKey(options),
  });
};

/**
 * Synchronize User with LearnUpon
 */
export const synchronizeUserMutation = (
  options?: Partial<Options<SynchronizeUserData>>,
): UseMutationOptions<
  unknown,
  SynchronizeUserError,
  Options<SynchronizeUserData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    SynchronizeUserError,
    Options<SynchronizeUserData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await synchronizeUser({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Handle LearnUpon webhook event
 */
export const learnUponWebhookMutation = (
  options?: Partial<Options<LearnUponWebhookData>>,
): UseMutationOptions<
  LearnUponWebhookResponse,
  LearnUponWebhookError,
  Options<LearnUponWebhookData>
> => {
  const mutationOptions: UseMutationOptions<
    LearnUponWebhookResponse,
    LearnUponWebhookError,
    Options<LearnUponWebhookData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await learnUponWebhook({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Course by ID
 */
export const deleteCourseMutation = (
  options?: Partial<Options<DeleteCourseData>>,
): UseMutationOptions<
  unknown,
  DeleteCourseError,
  Options<DeleteCourseData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DeleteCourseError,
    Options<DeleteCourseData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteCourse({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCourseByIdQueryKey = (options: Options<GetCourseByIdData>) =>
  createQueryKey('getCourseById', options);

/**
 * Get Course by ID
 */
export const getCourseByIdOptions = (options: Options<GetCourseByIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCourseById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCourseByIdQueryKey(options),
  });
};

/**
 * Update a course
 */
export const updateCourseMutation = (
  options?: Partial<Options<UpdateCourseData>>,
): UseMutationOptions<
  UpdateCourseResponse,
  UpdateCourseError,
  Options<UpdateCourseData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateCourseResponse,
    UpdateCourseError,
    Options<UpdateCourseData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateCourse({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set course status by ID
 */
export const updateUserComplianceCourseDurationMutation = (
  options?: Partial<Options<UpdateUserComplianceCourseDurationData>>,
): UseMutationOptions<
  unknown,
  UpdateUserComplianceCourseDurationError,
  Options<UpdateUserComplianceCourseDurationData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    UpdateUserComplianceCourseDurationError,
    Options<UpdateUserComplianceCourseDurationData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateUserComplianceCourseDuration({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Start the Pathway Crawler to pull in and index third party content
 */
export const newIndexDocument1Mutation = (
  options?: Partial<Options<NewIndexDocument1Data>>,
): UseMutationOptions<
  NewIndexDocument1Response,
  NewIndexDocument1Error,
  Options<NewIndexDocument1Data>
> => {
  const mutationOptions: UseMutationOptions<
    NewIndexDocument1Response,
    NewIndexDocument1Error,
    Options<NewIndexDocument1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await newIndexDocument1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getJobStatusQueryKey = (options: Options<GetJobStatusData>) =>
  createQueryKey('getJobStatus', options);

/**
 * Get the status of an index job
 */
export const getJobStatusOptions = (options: Options<GetJobStatusData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJobStatus({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJobStatusQueryKey(options),
  });
};

/**
 * Start the Pathway Crawler to pull in and index third party content
 */
export const newIndexDocumentMutation = (
  options?: Partial<Options<NewIndexDocumentData>>,
): UseMutationOptions<
  NewIndexDocumentResponse,
  NewIndexDocumentError,
  Options<NewIndexDocumentData>
> => {
  const mutationOptions: UseMutationOptions<
    NewIndexDocumentResponse,
    NewIndexDocumentError,
    Options<NewIndexDocumentData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await newIndexDocument({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add or update documents
 */
export const saveDocumentsMutation = (
  options?: Partial<Options<SaveDocumentsData>>,
): UseMutationOptions<
  unknown,
  SaveDocumentsError,
  Options<SaveDocumentsData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    SaveDocumentsError,
    Options<SaveDocumentsData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await saveDocuments({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const setAuthCookieQueryKey = (options?: Options<SetAuthCookieData>) =>
  createQueryKey('setAuthCookie', options);

/**
 * Sets auth cookie in response header
 */
export const setAuthCookieOptions = (options?: Options<SetAuthCookieData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await setAuthCookie({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: setAuthCookieQueryKey(options),
  });
};

/**
 * Migrate Xyleme document folder from external environment
 */
export const migrateFolderMutation = (
  options?: Partial<Options<MigrateFolderData>>,
): UseMutationOptions<
  unknown,
  MigrateFolderError,
  Options<MigrateFolderData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    MigrateFolderError,
    Options<MigrateFolderData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await migrateFolder({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete document by ID
 */
export const deleteDocumentMutation = (
  options?: Partial<Options<DeleteDocumentData>>,
): UseMutationOptions<
  DeleteDocumentResponse,
  DeleteDocumentError,
  Options<DeleteDocumentData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteDocumentResponse,
    DeleteDocumentError,
    Options<DeleteDocumentData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteDocument({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getDocumentQueryKey = (options: Options<GetDocumentData>) =>
  createQueryKey('getDocument', options);

/**
 * Get document by ID
 */
export const getDocumentOptions = (options: Options<GetDocumentData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getDocument({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getDocumentQueryKey(options),
  });
};

/**
 * Add Content Feedback record
 */
export const addContentFeedbackMutation = (
  options?: Partial<Options<AddContentFeedbackData>>,
): UseMutationOptions<
  AddContentFeedbackResponse,
  AddContentFeedbackError,
  Options<AddContentFeedbackData>
> => {
  const mutationOptions: UseMutationOptions<
    AddContentFeedbackResponse,
    AddContentFeedbackError,
    Options<AddContentFeedbackData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await addContentFeedback({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete content feedback by id.
 */
export const deleteContentFeedbackMutation = (
  options?: Partial<Options<DeleteContentFeedbackData>>,
): UseMutationOptions<
  unknown,
  DeleteContentFeedbackError,
  Options<DeleteContentFeedbackData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DeleteContentFeedbackError,
    Options<DeleteContentFeedbackData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteContentFeedback({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Get Training Checklists based upon Request
 */
export const getFilteredPlans1Mutation = (
  options?: Partial<Options<GetFilteredPlans1Data>>,
): UseMutationOptions<
  GetFilteredPlans1Response,
  GetFilteredPlans1Error,
  Options<GetFilteredPlans1Data>
> => {
  const mutationOptions: UseMutationOptions<
    GetFilteredPlans1Response,
    GetFilteredPlans1Error,
    Options<GetFilteredPlans1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await getFilteredPlans1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getAllQueryKey = (options?: Options<GetAllData>) =>
  createQueryKey('getAll', options);

/**
 * List All Games
 */
export const getAllOptions = (options?: Options<GetAllData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAll({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllQueryKey(options),
  });
};

/**
 * Add a Course
 */
export const addMutation = (
  options?: Partial<Options<AddData>>,
): UseMutationOptions<AddResponse, AddError, Options<AddData>> => {
  const mutationOptions: UseMutationOptions<
    AddResponse,
    AddError,
    Options<AddData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await add({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Course by ID
 */
export const deleteMutation = (
  options?: Partial<Options<DeleteData>>,
): UseMutationOptions<unknown, DeleteError, Options<DeleteData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DeleteError,
    Options<DeleteData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await delete_({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getByIdQueryKey = (options: Options<GetByIdData>) =>
  createQueryKey('getById', options);

/**
 * Get Course by ID
 */
export const getByIdOptions = (options: Options<GetByIdData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getByIdQueryKey(options),
  });
};

/**
 * Update a course
 */
export const updateMutation = (
  options?: Partial<Options<UpdateData>>,
): UseMutationOptions<UpdateResponse, UpdateError, Options<UpdateData>> => {
  const mutationOptions: UseMutationOptions<
    UpdateResponse,
    UpdateError,
    Options<UpdateData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await update({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCategoryIconsQueryKey = (
  options?: Options<GetCategoryIconsData>,
) => createQueryKey('getCategoryIcons', options);

/**
 * Get a list of all category icons
 */
export const getCategoryIconsOptions = (
  options?: Options<GetCategoryIconsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCategoryIcons({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCategoryIconsQueryKey(options),
  });
};

export const getProcedureIconsQueryKey = (
  options?: Options<GetProcedureIconsData>,
) => createQueryKey('getProcedureIcons', options);

/**
 * Get a list of all procedure icons
 */
export const getProcedureIconsOptions = (
  options?: Options<GetProcedureIconsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProcedureIcons({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProcedureIconsQueryKey(options),
  });
};

export const getLeadershipCoursesQueryKey = (
  options?: Options<GetLeadershipCoursesData>,
) => createQueryKey('getLeadershipCourses', options);

/**
 * List All Seasons
 */
export const getLeadershipCoursesOptions = (
  options?: Options<GetLeadershipCoursesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLeadershipCourses({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLeadershipCoursesQueryKey(options),
  });
};

export const getAscendOnDemandCoursesQueryKey = (
  options: Options<GetAscendOnDemandCoursesData>,
) => createQueryKey('getAscendOnDemandCourses', options);

/**
 * List Ascend On Demand Courses
 */
export const getAscendOnDemandCoursesOptions = (
  options: Options<GetAscendOnDemandCoursesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAscendOnDemandCourses({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAscendOnDemandCoursesQueryKey(options),
  });
};

/**
 * Delete Operator 'Like' on an Episode
 */
export const deleteOperatorLikeMutation = (
  options?: Partial<Options<DeleteOperatorLikeData>>,
): UseMutationOptions<
  unknown,
  DeleteOperatorLikeError,
  Options<DeleteOperatorLikeData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DeleteOperatorLikeError,
    Options<DeleteOperatorLikeData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteOperatorLike({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set Operator 'Like' on an Episode
 */
export const setOperatorLikeMutation = (
  options?: Partial<Options<SetOperatorLikeData>>,
): UseMutationOptions<
  unknown,
  SetOperatorLikeError,
  Options<SetOperatorLikeData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    SetOperatorLikeError,
    Options<SetOperatorLikeData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await setOperatorLike({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const createLocationPlansFromTemplatesMutation = (
  options?: Partial<Options<CreateLocationPlansFromTemplatesData>>,
): UseMutationOptions<
  CreateLocationPlansFromTemplatesResponse,
  CreateLocationPlansFromTemplatesError,
  Options<CreateLocationPlansFromTemplatesData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateLocationPlansFromTemplatesResponse,
    CreateLocationPlansFromTemplatesError,
    Options<CreateLocationPlansFromTemplatesData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await createLocationPlansFromTemplates({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getLocationsByConceptTypeQueryKey = (
  options: Options<GetLocationsByConceptTypeData>,
) => createQueryKey('getLocationsByConceptType', options);

/**
 * Get locations by concept type
 */
export const getLocationsByConceptTypeOptions = (
  options: Options<GetLocationsByConceptTypeData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLocationsByConceptType({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLocationsByConceptTypeQueryKey(options),
  });
};

export const getCurrentUserLocationsQueryKey = (
  options?: Options<GetCurrentUserLocationsData>,
) => createQueryKey('getCurrentUserLocations', options);

/**
 * Get current users locations
 */
export const getCurrentUserLocationsOptions = (
  options?: Options<GetCurrentUserLocationsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCurrentUserLocations({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCurrentUserLocationsQueryKey(options),
  });
};

export const getAllMarketTestsQueryKey = (
  options?: Options<GetAllMarketTestsData>,
) => createQueryKey('getAllMarketTests', options);

/**
 * List Market Tests
 */
export const getAllMarketTestsOptions = (
  options?: Options<GetAllMarketTestsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAllMarketTests({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAllMarketTestsQueryKey(options),
  });
};

/**
 * Add Market Tests (Including assigning locations)
 */
export const createMarketTestMutation = (
  options?: Partial<Options<CreateMarketTestData>>,
): UseMutationOptions<
  unknown,
  CreateMarketTestError,
  Options<CreateMarketTestData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    CreateMarketTestError,
    Options<CreateMarketTestData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await createMarketTest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMarketTestsByLocationQueryKey = (
  options: Options<GetMarketTestsByLocationData>,
) => createQueryKey('getMarketTestsByLocation', options);

/**
 * List Market Tests Assigned to Locations
 */
export const getMarketTestsByLocationOptions = (
  options: Options<GetMarketTestsByLocationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMarketTestsByLocation({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMarketTestsByLocationQueryKey(options),
  });
};

export const getMyMarketTestsQueryKey = (
  options?: Options<GetMyMarketTestsData>,
) => createQueryKey('getMyMarketTests', options);

/**
 * List Market Tests available to User
 */
export const getMyMarketTestsOptions = (
  options?: Options<GetMyMarketTestsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMyMarketTests({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMyMarketTestsQueryKey(options),
  });
};

/**
 * Delete market test by ID
 */
export const deleteMarketTestMutation = (
  options?: Partial<Options<DeleteMarketTestData>>,
): UseMutationOptions<
  DeleteMarketTestResponse,
  DeleteMarketTestError,
  Options<DeleteMarketTestData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteMarketTestResponse,
    DeleteMarketTestError,
    Options<DeleteMarketTestData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteMarketTest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMarketTestByIdQueryKey = (
  options: Options<GetMarketTestByIdData>,
) => createQueryKey('getMarketTestById', options);

/**
 * Get Market Test by ID
 */
export const getMarketTestByIdOptions = (
  options: Options<GetMarketTestByIdData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMarketTestById({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMarketTestByIdQueryKey(options),
  });
};

/**
 * Update a Market Test (Including assigning locations)
 */
export const updateMarketTestMutation = (
  options?: Partial<Options<UpdateMarketTestData>>,
): UseMutationOptions<
  unknown,
  UpdateMarketTestError,
  Options<UpdateMarketTestData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    UpdateMarketTestError,
    Options<UpdateMarketTestData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateMarketTest({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getMarketTestDocumentsQueryKey = (
  options: Options<GetMarketTestDocumentsData>,
) => createQueryKey('getMarketTestDocuments', options);

/**
 * Get Procedures by Market Test ID
 */
export const getMarketTestDocumentsOptions = (
  options: Options<GetMarketTestDocumentsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getMarketTestDocuments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getMarketTestDocumentsQueryKey(options),
  });
};

/**
 * Update Procedures within a Market Test
 */
export const setMarketTestProceduresMutation = (
  options?: Partial<Options<SetMarketTestProceduresData>>,
): UseMutationOptions<
  unknown,
  SetMarketTestProceduresError,
  Options<SetMarketTestProceduresData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    SetMarketTestProceduresError,
    Options<SetMarketTestProceduresData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await setMarketTestProcedures({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCustomQuizzes1QueryKey = (
  options?: Options<GetCustomQuizzes1Data>,
) => createQueryKey('getCustomQuizzes1', options);

/**
 * Gets a list of custom quizzes
 */
export const getCustomQuizzes1Options = (
  options?: Options<GetCustomQuizzes1Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCustomQuizzes1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCustomQuizzes1QueryKey(options),
  });
};

/**
 * Create a custom quiz
 */
export const createCustomQuiz1Mutation = (
  options?: Partial<Options<CreateCustomQuiz1Data>>,
): UseMutationOptions<
  CreateCustomQuiz1Response,
  CreateCustomQuiz1Error,
  Options<CreateCustomQuiz1Data>
> => {
  const mutationOptions: UseMutationOptions<
    CreateCustomQuiz1Response,
    CreateCustomQuiz1Error,
    Options<CreateCustomQuiz1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await createCustomQuiz1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Edit a custom quiz
 */
export const updateCustomQuiz1Mutation = (
  options?: Partial<Options<UpdateCustomQuiz1Data>>,
): UseMutationOptions<
  UpdateCustomQuiz1Response,
  UpdateCustomQuiz1Error,
  Options<UpdateCustomQuiz1Data>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateCustomQuiz1Response,
    UpdateCustomQuiz1Error,
    Options<UpdateCustomQuiz1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateCustomQuiz1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete custom quiz
 */
export const deleteCustomQuiz1Mutation = (
  options?: Partial<Options<DeleteCustomQuiz1Data>>,
): UseMutationOptions<
  unknown,
  DeleteCustomQuiz1Error,
  Options<DeleteCustomQuiz1Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DeleteCustomQuiz1Error,
    Options<DeleteCustomQuiz1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteCustomQuiz1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCustomQuizDetails1QueryKey = (
  options: Options<GetCustomQuizDetails1Data>,
) => createQueryKey('getCustomQuizDetails1', options);

/**
 * Get custom quiz details
 */
export const getCustomQuizDetails1Options = (
  options: Options<GetCustomQuizDetails1Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCustomQuizDetails1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCustomQuizDetails1QueryKey(options),
  });
};

export const listRelatedDocumentsQueryKey = (
  options: Options<ListRelatedDocumentsData>,
) => createQueryKey('listRelatedDocuments', options);

/**
 * query Xyleme for related documents
 */
export const listRelatedDocumentsOptions = (
  options: Options<ListRelatedDocumentsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listRelatedDocuments({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listRelatedDocumentsQueryKey(options),
  });
};

export const reportPlansQueryKey = (options?: Options<ReportPlansData>) =>
  createQueryKey('reportPlans', options);

/**
 * Get assignable plans with assignment totals
 * Reports will automatically be returned for all locations the user can report on which includes licensee locations (if applicable). You can optionally filter locations by using query param `locationIds`. For Brand Champions, valid licensee location ids **are** required.
 */
export const reportPlansOptions = (options?: Options<ReportPlansData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportPlans({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: reportPlansQueryKey(options),
  });
};

export const reportTeamMemberQueryKey = (
  options: Options<ReportTeamMemberData>,
) => createQueryKey('reportTeamMember', options);

/**
 * Get user's training plans by userId
 */
export const reportTeamMemberOptions = (
  options: Options<ReportTeamMemberData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportTeamMember({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: reportTeamMemberQueryKey(options),
  });
};

export const reportTeamMembersQueryKey = (
  options?: Options<ReportTeamMembersData>,
) => createQueryKey('reportTeamMembers', options);

/**
 * Get team members plan assignment totals
 * Reports will automatically be returned for all locations the user can report on which includes licensee locations (if applicable). You can optionally filter locations by using query param `locationIds`. For Brand Champions, valid licensee location ids **are** required.
 */
export const reportTeamMembersOptions = (
  options?: Options<ReportTeamMembersData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportTeamMembers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: reportTeamMembersQueryKey(options),
  });
};

export const reportUsersProgressQueryKey = (
  options: Options<ReportUsersProgressData>,
) => createQueryKey('reportUsersProgress', options);

/**
 * Get users progress for a specific plan
 * Reports will automatically be returned for all locations the user can report on which includes licensee locations (if applicable). You can optionally filter locations by using query param `locationIds`. For Brand Champions, valid licensee location ids **are** required.
 */
export const reportUsersProgressOptions = (
  options: Options<ReportUsersProgressData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportUsersProgress({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: reportUsersProgressQueryKey(options),
  });
};

/**
 * Translate
 */
export const translateMutation = (
  options?: Partial<Options<TranslateData>>,
): UseMutationOptions<
  TranslateResponse,
  TranslateError,
  Options<TranslateData>
> => {
  const mutationOptions: UseMutationOptions<
    TranslateResponse,
    TranslateError,
    Options<TranslateData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await translate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listSubcategoriesQueryKey = (
  options?: Options<ListSubcategoriesData>,
) => createQueryKey('listSubcategories', options);

/**
 * List subcategories
 * @deprecated
 */
export const listSubcategoriesOptions = (
  options?: Options<ListSubcategoriesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSubcategories({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listSubcategoriesQueryKey(options),
  });
};

/**
 * Add or update subcategories
 * @deprecated
 */
export const saveSubcategoriesMutation = (
  options?: Partial<Options<SaveSubcategoriesData>>,
): UseMutationOptions<
  unknown,
  DefaultError,
  Options<SaveSubcategoriesData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<SaveSubcategoriesData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await saveSubcategories({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete subcategory by ID
 * @deprecated
 */
export const deleteSubcategoryMutation = (
  options?: Partial<Options<DeleteSubcategoryData>>,
): UseMutationOptions<
  DeleteSubcategoryResponse,
  DefaultError,
  Options<DeleteSubcategoryData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteSubcategoryResponse,
    DefaultError,
    Options<DeleteSubcategoryData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteSubcategory({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSubcategoryQueryKey = (options: Options<GetSubcategoryData>) =>
  createQueryKey('getSubcategory', options);

/**
 * Get category by ID
 * @deprecated
 */
export const getSubcategoryOptions = (options: Options<GetSubcategoryData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSubcategory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSubcategoryQueryKey(options),
  });
};

export const listSubtitlesQueryKey = (options?: Options<ListSubtitlesData>) =>
  createQueryKey('listSubtitles', options);

/**
 * List subtitles
 * @deprecated
 */
export const listSubtitlesOptions = (options?: Options<ListSubtitlesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listSubtitles({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listSubtitlesQueryKey(options),
  });
};

/**
 * Add or update subtitle
 * @deprecated
 */
export const saveSubtitlesMutation = (
  options?: Partial<Options<SaveSubtitlesData>>,
): UseMutationOptions<unknown, DefaultError, Options<SaveSubtitlesData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DefaultError,
    Options<SaveSubtitlesData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await saveSubtitles({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete subtitle by ID
 * @deprecated
 */
export const deleteSubtitleMutation = (
  options?: Partial<Options<DeleteSubtitleData>>,
): UseMutationOptions<
  DeleteSubtitleResponse,
  DefaultError,
  Options<DeleteSubtitleData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteSubtitleResponse,
    DefaultError,
    Options<DeleteSubtitleData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteSubtitle({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getSubtitleQueryKey = (options: Options<GetSubtitleData>) =>
  createQueryKey('getSubtitle', options);

/**
 * Get subtitle by ID
 * @deprecated
 */
export const getSubtitleOptions = (options: Options<GetSubtitleData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getSubtitle({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getSubtitleQueryKey(options),
  });
};

/**
 * Create a checklist
 */
export const saveChecklist1Mutation = (
  options?: Partial<Options<SaveChecklist1Data>>,
): UseMutationOptions<
  SaveChecklist1Response,
  SaveChecklist1Error,
  Options<SaveChecklist1Data>
> => {
  const mutationOptions: UseMutationOptions<
    SaveChecklist1Response,
    SaveChecklist1Error,
    Options<SaveChecklist1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await saveChecklist1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update a checklist
 */
export const updateChecklist1Mutation = (
  options?: Partial<Options<UpdateChecklist1Data>>,
): UseMutationOptions<
  unknown,
  UpdateChecklist1Error,
  Options<UpdateChecklist1Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    UpdateChecklist1Error,
    Options<UpdateChecklist1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateChecklist1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listChecklistsQueryKey = (options?: Options<ListChecklistsData>) =>
  createQueryKey('listChecklists', options);

/**
 * List all training checklists
 */
export const listChecklistsOptions = (
  options?: Options<ListChecklistsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listChecklists({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listChecklistsQueryKey(options),
  });
};

export const listAssignableChecklists1QueryKey = (
  options?: Options<ListAssignableChecklists1Data>,
) => createQueryKey('listAssignableChecklists1', options);

/**
 * List all training checklists the active user can assign users to, as well as their assigned counts
 */
export const listAssignableChecklists1Options = (
  options?: Options<ListAssignableChecklists1Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAssignableChecklists1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAssignableChecklists1QueryKey(options),
  });
};

export const listAssignedChecklistsQueryKey = (
  options?: Options<ListAssignedChecklistsData>,
) => createQueryKey('listAssignedChecklists', options);

/**
 * List assigned training checklists
 */
export const listAssignedChecklistsOptions = (
  options?: Options<ListAssignedChecklistsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAssignedChecklists({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAssignedChecklistsQueryKey(options),
  });
};

export const listAssignedByChecklist1QueryKey = (
  options: Options<ListAssignedByChecklist1Data>,
) => createQueryKey('listAssignedByChecklist1', options);

/**
 * Status of all assigned users to this training checklist
 */
export const listAssignedByChecklist1Options = (
  options: Options<ListAssignedByChecklist1Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAssignedByChecklist1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAssignedByChecklist1QueryKey(options),
  });
};

export const listEditableChecklists1QueryKey = (
  options?: Options<ListEditableChecklists1Data>,
) => createQueryKey('listEditableChecklists1', options);

/**
 * List all training checklists the active user can edit/modify
 */
export const listEditableChecklists1Options = (
  options?: Options<ListEditableChecklists1Data>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listEditableChecklists1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listEditableChecklists1QueryKey(options),
  });
};

export const listMyChecklistsQueryKey = (
  options?: Options<ListMyChecklistsData>,
) => createQueryKey('listMyChecklists', options);

/**
 * List assigned training checklists
 */
export const listMyChecklistsOptions = (
  options?: Options<ListMyChecklistsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listMyChecklists({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listMyChecklistsQueryKey(options),
  });
};

/**
 * Reset current state of Checklist for a user
 */
export const resetAllChecklistStepsState1Mutation = (
  options?: Partial<Options<ResetAllChecklistStepsState1Data>>,
): UseMutationOptions<
  ResetAllChecklistStepsState1Response,
  ResetAllChecklistStepsState1Error,
  Options<ResetAllChecklistStepsState1Data>
> => {
  const mutationOptions: UseMutationOptions<
    ResetAllChecklistStepsState1Response,
    ResetAllChecklistStepsState1Error,
    Options<ResetAllChecklistStepsState1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await resetAllChecklistStepsState1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listChecklistTemplatesQueryKey = (
  options?: Options<ListChecklistTemplatesData>,
) => createQueryKey('listChecklistTemplates', options);

/**
 * List all training checklist templates
 */
export const listChecklistTemplatesOptions = (
  options?: Options<ListChecklistTemplatesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listChecklistTemplates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listChecklistTemplatesQueryKey(options),
  });
};

/**
 * Update a checklist template
 */
export const duplicateChecklistTemplateMutation = (
  options?: Partial<Options<DuplicateChecklistTemplateData>>,
): UseMutationOptions<
  DuplicateChecklistTemplateResponse,
  DuplicateChecklistTemplateError,
  Options<DuplicateChecklistTemplateData>
> => {
  const mutationOptions: UseMutationOptions<
    DuplicateChecklistTemplateResponse,
    DuplicateChecklistTemplateError,
    Options<DuplicateChecklistTemplateData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await duplicateChecklistTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Unassign one or more Team members to a Checklist
 */
export const unassignUsersToChecklist1Mutation = (
  options?: Partial<Options<UnassignUsersToChecklist1Data>>,
): UseMutationOptions<
  unknown,
  UnassignUsersToChecklist1Error,
  Options<UnassignUsersToChecklist1Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    UnassignUsersToChecklist1Error,
    Options<UnassignUsersToChecklist1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await unassignUsersToChecklist1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Assign one or more Team members to a Checklist
 */
export const assignUsersToChecklist1Mutation = (
  options?: Partial<Options<AssignUsersToChecklist1Data>>,
): UseMutationOptions<
  unknown,
  AssignUsersToChecklist1Error,
  Options<AssignUsersToChecklist1Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AssignUsersToChecklist1Error,
    Options<AssignUsersToChecklist1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await assignUsersToChecklist1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set Due Date on one or more Team members assigned to a Checklist
 */
export const setDueDateOnChecklist1Mutation = (
  options?: Partial<Options<SetDueDateOnChecklist1Data>>,
): UseMutationOptions<
  unknown,
  SetDueDateOnChecklist1Error,
  Options<SetDueDateOnChecklist1Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    SetDueDateOnChecklist1Error,
    Options<SetDueDateOnChecklist1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await setDueDateOnChecklist1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set checklist status by ID
 */
export const updateChecklistStatus1Mutation = (
  options?: Partial<Options<UpdateChecklistStatus1Data>>,
): UseMutationOptions<
  unknown,
  UpdateChecklistStatus1Error,
  Options<UpdateChecklistStatus1Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    UpdateChecklistStatus1Error,
    Options<UpdateChecklistStatus1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateChecklistStatus1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set checklist step status by ID
 */
export const updateChecklistStepStatusMutation = (
  options?: Partial<Options<UpdateChecklistStepStatusData>>,
): UseMutationOptions<
  unknown,
  UpdateChecklistStepStatusError,
  Options<UpdateChecklistStepStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    UpdateChecklistStepStatusError,
    Options<UpdateChecklistStepStatusData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateChecklistStepStatus({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getChecklistByUserIdsQueryKey = (
  options: Options<GetChecklistByUserIdsData>,
) => createQueryKey('getChecklistByUserIds', options);

/**
 * Get User Checklist by Checklist ID and User IDs
 */
export const getChecklistByUserIdsOptions = (
  options: Options<GetChecklistByUserIdsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getChecklistByUserIds({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getChecklistByUserIdsQueryKey(options),
  });
};

/**
 * Update a checklist
 */
export const duplicateChecklist1Mutation = (
  options?: Partial<Options<DuplicateChecklist1Data>>,
): UseMutationOptions<
  DuplicateChecklist1Response,
  DuplicateChecklist1Error,
  Options<DuplicateChecklist1Data>
> => {
  const mutationOptions: UseMutationOptions<
    DuplicateChecklist1Response,
    DuplicateChecklist1Error,
    Options<DuplicateChecklist1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await duplicateChecklist1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete checklist by ID
 */
export const deleteChecklist1Mutation = (
  options?: Partial<Options<DeleteChecklist1Data>>,
): UseMutationOptions<
  unknown,
  DeleteChecklist1Error,
  Options<DeleteChecklist1Data>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DeleteChecklist1Error,
    Options<DeleteChecklist1Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteChecklist1({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getChecklist1QueryKey = (options: Options<GetChecklist1Data>) =>
  createQueryKey('getChecklist1', options);

/**
 * Get checklist by ID
 */
export const getChecklist1Options = (options: Options<GetChecklist1Data>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getChecklist1({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getChecklist1QueryKey(options),
  });
};

export const getTeamMembersStatusReportQueryKey = (
  options?: Options<GetTeamMembersStatusReportData>,
) => createQueryKey('getTeamMembersStatusReport', options);

/**
 * Get checklist status report for team members
 */
export const getTeamMembersStatusReportOptions = (
  options?: Options<GetTeamMembersStatusReportData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTeamMembersStatusReport({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTeamMembersStatusReportQueryKey(options),
  });
};

/**
 * Get Training Checklists based upon Request
 */
export const getFilteredPlansMutation = (
  options?: Partial<Options<GetFilteredPlansData>>,
): UseMutationOptions<
  GetFilteredPlansResponse,
  GetFilteredPlansError,
  Options<GetFilteredPlansData>
> => {
  const mutationOptions: UseMutationOptions<
    GetFilteredPlansResponse,
    GetFilteredPlansError,
    Options<GetFilteredPlansData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await getFilteredPlans({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCustomQuizzesQueryKey = (
  options?: Options<GetCustomQuizzesData>,
) => createQueryKey('getCustomQuizzes', options);

/**
 * Gets a list of custom quizzes
 */
export const getCustomQuizzesOptions = (
  options?: Options<GetCustomQuizzesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCustomQuizzes({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCustomQuizzesQueryKey(options),
  });
};

/**
 * Create a custom quiz
 */
export const createCustomQuizMutation = (
  options?: Partial<Options<CreateCustomQuizData>>,
): UseMutationOptions<
  CreateCustomQuizResponse,
  CreateCustomQuizError,
  Options<CreateCustomQuizData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateCustomQuizResponse,
    CreateCustomQuizError,
    Options<CreateCustomQuizData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await createCustomQuiz({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Edit a custom quiz
 */
export const updateCustomQuizMutation = (
  options?: Partial<Options<UpdateCustomQuizData>>,
): UseMutationOptions<
  UpdateCustomQuizResponse,
  UpdateCustomQuizError,
  Options<UpdateCustomQuizData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateCustomQuizResponse,
    UpdateCustomQuizError,
    Options<UpdateCustomQuizData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateCustomQuiz({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete custom quiz
 */
export const deleteCustomQuizMutation = (
  options?: Partial<Options<DeleteCustomQuizData>>,
): UseMutationOptions<
  DeleteCustomQuizResponse,
  DeleteCustomQuizError,
  Options<DeleteCustomQuizData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteCustomQuizResponse,
    DeleteCustomQuizError,
    Options<DeleteCustomQuizData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteCustomQuiz({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCustomQuizDetailsQueryKey = (
  options: Options<GetCustomQuizDetailsData>,
) => createQueryKey('getCustomQuizDetails', options);

/**
 * Get custom quiz details
 */
export const getCustomQuizDetailsOptions = (
  options: Options<GetCustomQuizDetailsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCustomQuizDetails({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCustomQuizDetailsQueryKey(options),
  });
};

export const listUsersQueryKey = (options?: Options<ListUsersData>) =>
  createQueryKey('listUsers', options);

/**
 * Get users by locations
 */
export const listUsersOptions = (options?: Options<ListUsersData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listUsers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listUsersQueryKey(options),
  });
};

export const listOperatorsQueryKey = (options?: Options<ListOperatorsData>) =>
  createQueryKey('listOperators', options);

/**
 * Get operators and locations
 */
export const listOperatorsOptions = (options?: Options<ListOperatorsData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listOperators({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listOperatorsQueryKey(options),
  });
};

export const retrieveUserPreferencesQueryKey = (
  options?: Options<RetrieveUserPreferencesData>,
) => createQueryKey('retrieveUserPreferences', options);

/**
 * Retrieve user preferences
 */
export const retrieveUserPreferencesOptions = (
  options?: Options<RetrieveUserPreferencesData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await retrieveUserPreferences({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: retrieveUserPreferencesQueryKey(options),
  });
};

/**
 * Save user preferences
 */
export const saveUserPreferencesMutation = (
  options?: Partial<Options<SaveUserPreferencesData>>,
): UseMutationOptions<
  SaveUserPreferencesResponse,
  SaveUserPreferencesError,
  Options<SaveUserPreferencesData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveUserPreferencesResponse,
    SaveUserPreferencesError,
    Options<SaveUserPreferencesData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await saveUserPreferences({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create a checklist
 */
export const saveChecklistMutation = (
  options?: Partial<Options<SaveChecklistData>>,
): UseMutationOptions<
  SaveChecklistResponse,
  SaveChecklistError,
  Options<SaveChecklistData>
> => {
  const mutationOptions: UseMutationOptions<
    SaveChecklistResponse,
    SaveChecklistError,
    Options<SaveChecklistData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await saveChecklist({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update a checklist
 */
export const updateChecklistMutation = (
  options?: Partial<Options<UpdateChecklistData>>,
): UseMutationOptions<
  unknown,
  UpdateChecklistError,
  Options<UpdateChecklistData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    UpdateChecklistError,
    Options<UpdateChecklistData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateChecklist({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listAllChecklistsQueryKey = (
  options?: Options<ListAllChecklistsData>,
) => createQueryKey('listAllChecklists', options);

/**
 * List all training plans
 */
export const listAllChecklistsOptions = (
  options?: Options<ListAllChecklistsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAllChecklists({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAllChecklistsQueryKey(options),
  });
};

export const listAssignableChecklistsQueryKey = (
  options?: Options<ListAssignableChecklistsData>,
) => createQueryKey('listAssignableChecklists', options);

/**
 * List all training plans the active user can assign users to, as well as their assigned counts
 */
export const listAssignableChecklistsOptions = (
  options?: Options<ListAssignableChecklistsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAssignableChecklists({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAssignableChecklistsQueryKey(options),
  });
};

export const listAssignedByChecklistQueryKey = (
  options: Options<ListAssignedByChecklistData>,
) => createQueryKey('listAssignedByChecklist', options);

/**
 * Status of all assigned users to this training checklist
 */
export const listAssignedByChecklistOptions = (
  options: Options<ListAssignedByChecklistData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listAssignedByChecklist({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listAssignedByChecklistQueryKey(options),
  });
};

export const listEditableChecklistsQueryKey = (
  options?: Options<ListEditableChecklistsData>,
) => createQueryKey('listEditableChecklists', options);

/**
 * List all training checklists the active user can edit/modify
 */
export const listEditableChecklistsOptions = (
  options?: Options<ListEditableChecklistsData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listEditableChecklists({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listEditableChecklistsQueryKey(options),
  });
};

/**
 * Reset current state of Checklist for a user
 */
export const resetAllChecklistStepsStateMutation = (
  options?: Partial<Options<ResetAllChecklistStepsStateData>>,
): UseMutationOptions<
  ResetAllChecklistStepsStateResponse,
  ResetAllChecklistStepsStateError,
  Options<ResetAllChecklistStepsStateData>
> => {
  const mutationOptions: UseMutationOptions<
    ResetAllChecklistStepsStateResponse,
    ResetAllChecklistStepsStateError,
    Options<ResetAllChecklistStepsStateData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await resetAllChecklistStepsState({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getTemplatesQueryKey = (options?: Options<GetTemplatesData>) =>
  createQueryKey('getTemplates', options);

/**
 * Get plan templates
 */
export const getTemplatesOptions = (options?: Options<GetTemplatesData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getTemplates({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getTemplatesQueryKey(options),
  });
};

/**
 * Create a plan from a template
 */
export const createChecklistFromTemplateMutation = (
  options?: Partial<Options<CreateChecklistFromTemplateData>>,
): UseMutationOptions<
  CreateChecklistFromTemplateResponse,
  CreateChecklistFromTemplateError,
  Options<CreateChecklistFromTemplateData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateChecklistFromTemplateResponse,
    CreateChecklistFromTemplateError,
    Options<CreateChecklistFromTemplateData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await createChecklistFromTemplate({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete checklist by ID
 */
export const deleteChecklistMutation = (
  options?: Partial<Options<DeleteChecklistData>>,
): UseMutationOptions<
  unknown,
  DeleteChecklistError,
  Options<DeleteChecklistData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    DeleteChecklistError,
    Options<DeleteChecklistData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await deleteChecklist({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getChecklistQueryKey = (options: Options<GetChecklistData>) =>
  createQueryKey('getChecklist', options);

/**
 * Get checklist by ID
 */
export const getChecklistOptions = (options: Options<GetChecklistData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getChecklist({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getChecklistQueryKey(options),
  });
};

/**
 * Unassign one or more Team members to a Checklist
 */
export const unassignUsersToChecklistMutation = (
  options?: Partial<Options<UnassignUsersToChecklistData>>,
): UseMutationOptions<
  unknown,
  UnassignUsersToChecklistError,
  Options<UnassignUsersToChecklistData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    UnassignUsersToChecklistError,
    Options<UnassignUsersToChecklistData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await unassignUsersToChecklist({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Assign one or more Team members to a Checklist
 */
export const assignUsersToChecklistMutation = (
  options?: Partial<Options<AssignUsersToChecklistData>>,
): UseMutationOptions<
  unknown,
  AssignUsersToChecklistError,
  Options<AssignUsersToChecklistData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AssignUsersToChecklistError,
    Options<AssignUsersToChecklistData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await assignUsersToChecklist({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set Due Date on one or more Team members assigned to a Checklist
 */
export const setDueDateOnChecklistMutation = (
  options?: Partial<Options<SetDueDateOnChecklistData>>,
): UseMutationOptions<
  unknown,
  SetDueDateOnChecklistError,
  Options<SetDueDateOnChecklistData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    SetDueDateOnChecklistError,
    Options<SetDueDateOnChecklistData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await setDueDateOnChecklist({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Set checklist status by ID
 */
export const updateChecklistStatusMutation = (
  options?: Partial<Options<UpdateChecklistStatusData>>,
): UseMutationOptions<
  unknown,
  UpdateChecklistStatusError,
  Options<UpdateChecklistStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    UpdateChecklistStatusError,
    Options<UpdateChecklistStatusData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateChecklistStatus({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 *  Increment the time a user or trainer has spent on a checklist step via heartbeat mechanism.
 */
export const stepHeartbeatMutation = (
  options?: Partial<Options<StepHeartbeatData>>,
): UseMutationOptions<
  unknown,
  StepHeartbeatError,
  Options<StepHeartbeatData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    StepHeartbeatError,
    Options<StepHeartbeatData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await stepHeartbeat({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update a checklist step status for a user or trainer.
 */
export const updateStepStatusMutation = (
  options?: Partial<Options<UpdateStepStatusData>>,
): UseMutationOptions<
  unknown,
  UpdateStepStatusError,
  Options<UpdateStepStatusData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    UpdateStepStatusError,
    Options<UpdateStepStatusData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await updateStepStatus({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Duplicate a plan
 */
export const duplicateChecklistMutation = (
  options?: Partial<Options<DuplicateChecklistData>>,
): UseMutationOptions<
  DuplicateChecklistResponse,
  DuplicateChecklistError,
  Options<DuplicateChecklistData>
> => {
  const mutationOptions: UseMutationOptions<
    DuplicateChecklistResponse,
    DuplicateChecklistError,
    Options<DuplicateChecklistData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await duplicateChecklist({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Handle LearnUpon webhook v2 event
 */
export const learnUponWebhookV2Mutation = (
  options?: Partial<Options<LearnUponWebhookV2Data>>,
): UseMutationOptions<
  LearnUponWebhookV2Response,
  LearnUponWebhookV2Error,
  Options<LearnUponWebhookV2Data>
> => {
  const mutationOptions: UseMutationOptions<
    LearnUponWebhookV2Response,
    LearnUponWebhookV2Error,
    Options<LearnUponWebhookV2Data>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await learnUponWebhookV2({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Handle webhook quiz event
 */
export const typeformQuizMutation = (
  options?: Partial<Options<TypeformQuizData>>,
): UseMutationOptions<
  unknown,
  TypeformQuizError,
  Options<TypeformQuizData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    TypeformQuizError,
    Options<TypeformQuizData>
  > = {
    mutationFn: async fnOptions => {
      const { data } = await typeformQuiz({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};
